/* eslint-disable max-len */
import React from 'react';
import { object } from 'prop-types';
import StoryCardContentWithSummaryAuthor from '../../story-card-content/with-summary-author';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import { contentClick } from '../../../../helpers/datalayer-utils';
import './story-card-horizontal-with-image-all-content.m.css';


const StoryCardHorizontalWithImageAllContent = ({ story }) => {
  const userData = useSelector((state) => get(state, ['userData']));
  const pageType = useSelector((state) => get(state, ['qt', 'pageType']));
  return (
    <div styleName="story-card" onClick={() => contentClick(userData, story, pageType)}>
      <div styleName="story-link">
        <a styleName="story-image" href={new URL(story?.link)?.pathname}>
          <img src={story?.thumb_image + '?downsize=230:130'} alt="thumb image" styleName="thumb-image" />
        </a>
        <StoryCardContentWithSummaryAuthor story={story} />
      </div>
    </div>
  );
};

StoryCardHorizontalWithImageAllContent.propTypes = {
  story: object.isRequired,
};

export default StoryCardHorizontalWithImageAllContent;
